export const X_TF_ECOMMERCE = 'X-TF-ECOMMERCE'
export const FEES_STYLES = { TRADITIONAL: 'TRADITIONAL', DISPLAY_BOTH: 'DISPLAY_BOTH' }
export const DEFAULT_FEES_STYLE = FEES_STYLES.TRADITIONAL
